import { Button, ButtonProps } from '@/components/ui/button'
import { ReactNode } from 'react'
import { Link, LinkProps } from '@tanstack/react-router'

interface StatusScreenProps {
  image: string
  alt: string
  title: string
  description: string
  linkProps?: LinkProps
  buttonProps?: ButtonProps
  buttonContent?: ReactNode
}

export function StatusScreen(props: StatusScreenProps) {
  const {
    image,
    alt,
    title,
    description,
    linkProps,
    buttonContent,
    buttonProps,
  } = props
  return (
    <>
      <div className={'flex flex-1 flex-col items-center justify-center'}>
        <img src={image} alt={alt} className={'size-[150px]'} />
        <section className={'flex flex-col gap-3 text-center'}>
          <h2 className={'text-xl font-semibold'}>{title}</h2>
          <p>{description}</p>
        </section>
      </div>
      {linkProps ? (
        <Button asChild {...buttonProps}>
          <Link {...linkProps}>{buttonContent}</Link>
        </Button>
      ) : buttonProps ? (
        <Button {...buttonProps}>{buttonContent}</Button>
      ) : null}
    </>
  )
}
